import * as React from 'react';
import { Row } from './row';
import { Title } from '@dropbox/dig-components/typography';
export const Group = ({ group, useHrefDirectly, }) => {
    if (!group.items) {
        return null;
    }
    return (React.createElement("div", { className: "dpc-Waffle-group" },
        group.title && (React.createElement(Title, { size: "small", className: "dpc-Waffle-group-title" }, group.title)),
        group.items.map((item) => (React.createElement(Row, { item: item, key: item.title, useHrefDirectly: useHrefDirectly })))));
};
Group.displayName = 'Group';
